<template>
  <div>
    <section id="sub_visual" class="pic07">
      <p>이트너스 DMS 소개</p>
      <span>About etnersDMS Service</span> </section>
    <main id="page_sub">
      <section id="page_contents" class="clear"> <span class="exr"><img src="../../assets/images/exr_03.png" alt=""/></span>
        <h6 class="w50p">클라이언트 디바이스<br/>
          라이프 사이클을 무한대로 ∞</h6>
        <span class="ctext1 w50p">태블릿  배송부터 회수, 재고관리까지 이트너스 DMS가 한번에 해결해 드립니다.</span>
        <p class="ctext2 pt50"><span class="cbig">Why</span><span>etners DMS?</span></p>
        <!--- 특징 --->
        <div class="clearfix">
          <ul class="platform">
            <li>
              <p><img src="../../assets/images/c_im_25.png" width="104" height="104" alt=""/></p>
              <h6>체계적인 디바이스 관리</h6>
              <p>다년간의 물류 운영 솔루션 노하우를 통해 언제나 기기를 최상의 상태로 유지합니다.</p>
            <li>
              <p><img src="../../assets/images/c_im_26.png" width="104" height="104" alt=""/></p>
              <h6>철저한 보안 및 운영 시스템 구축</h6>
              <p>자체 솔루션으로 클라이언트에 맞는 시스템을 개발 지원하고, 모든 현장공간에 카메라를 설치하여 클레임에 대비합니다.</p>
            </li>
            <li>
              <p><img src="../../assets/images/c_im_27.png" width="104" height="104" alt=""/></p>
              <h6>DMS만의 신속한 공급망 구축</h6>
              <p>태블릿 적재, 적시 공금을 위한 공식 대리점 등록으로 최적의 모델을 추천하며 주변기기를 클라이언트사에 맞춰 제공합니다. </p>
            </li>
            <li>
              <p><img src="../../assets/images/c_im_28.png" width="104" height="104" alt=""/></p>
              <h6>디바이스 회전 최대 지원 및 매각 진행</h6>
              <p>리퍼비시 공정사이클을 지속적으로 카운팅하여 최대 사이클로 회전할수 잇게 하며, 성능이 떨어진 기기는 이트너스 비딩을 통해 매각 진행을 제공하고 있습니다.</p>
            </li>
          </ul>
        </div>
        <!--- //특징 --->
        <go-solution :solutionUrl="url" :solCd="solCd" :solGrup="10" :solNm="solNm"></go-solution>
      </section>
    </main>
  </div>
</template>

<script>
  import GoSolution from "../../components/goSolution";
  export default {
    components: {GoSolution},
    data() {
      return{
        url:'http://mega.etnersdms.com',
        solNm :'이트너스DMS',
        solCd : '2006'
      }
    }
  }

</script>
